/**
 * Porta de entrada do documento: onde o app foi aberto, antes de qualquer
 * navegação interna. Existe para um contorno pontual — o webview da DoIt abre
 * o Go!RN em `/jornadas` e o evento não executa jornadas. Redirecionar dentro
 * do app só para quem entrou por lá evita quebrar o clique em "Ver jornadas"
 * feito depois, já dentro da home.
 */
export type EntryDoor = {
  pathname: string
  search: string
  referrer: string
  ua: string
}

export const isDoityEntry = ({ search, referrer, ua }: EntryDoor): boolean => {
  const params = new URLSearchParams(search)
  return (
    params.get('partner') === 'doity' ||
    params.get('partner_id') === 'doity' ||
    referrer.includes('doity.com') ||
    ua.includes('DoityWebView')
  )
}

/** Destino que substitui `/jornadas` na entrada da DoIt; `null` = não interferir. */
export const journeysEscapeHref = (door: EntryDoor | null): string | null => {
  if (!door) return null
  if (door.pathname.replace(/\/$/, '') !== '/jornadas') return null
  if (!isDoityEntry(door)) return null
  // Preserva a query: o PartnerProvider lê `partner`, `id` e `email` dela.
  return `/${door.search}`
}

/** Entrega a porta uma única vez; navegações seguintes recebem `null`. */
export const createEntryDoor = (read: () => EntryDoor | null) => {
  let pending = read()
  return () => {
    const door = pending
    pending = null
    return door
  }
}

export const consumeEntryDoor = createEntryDoor(() =>
  typeof window === 'undefined'
    ? null
    : {
        pathname: window.location.pathname,
        search: window.location.search,
        referrer: document.referrer,
        ua: navigator.userAgent
      }
)
